import {Toggle} from '@/components/atoms'
import {DropdownWithTags, TabsComponent} from '@/components/molecules'
import {useGetProductAndBrandDropdown} from '@/hooks/promotion/useGetProductAndBrandDropdown'
import {SELECTION_TYPE} from '@/utils/constants/commonConstants'
import {useMemo} from 'react'
import {BuyType} from '@/utils/constants/promotionConstants'

const ProductAndBrandContent = ({
  activeTabIndex,
  selectedTags,
  combination,
  tabs,
  onTabChange,
  setSelectedTags,
  setCombination,
  isExclude,
}) => {
  const activeTab = tabs[activeTabIndex]
  const activeTabDropdownType = activeTab?.dropDownType
  const resolvedDropdownType = activeTabDropdownType === 'brands' ? 'display_brands' : activeTabDropdownType
  const {data, isLoading} = useGetProductAndBrandDropdown(resolvedDropdownType)
  const childList = useMemo(() => {
    return (
      data?.data?.map(({id, value}) => ({
        id: id,
        displayText: value,
      })) || []
    )
  }, [data])

  const selectedOptions = selectedTags.itemType === activeTab?.id ? selectedTags.values : []

  return (
    <>
      <TabsComponent tabList={tabs} defaultTabIndex={activeTabIndex} onTabChange={onTabChange} />
      <div>
        <DropdownWithTags
          childList={childList}
          onChange={value => {
            setSelectedTags({itemType: activeTab?.id || '', values: value})
          }}
          placeholder={selectedOptions.length > 0 ? 'Selected' : tabs?.[activeTabIndex]?.tabLabel}
          selectedOptions={selectedOptions}
          label={tabs?.[activeTabIndex]?.tabLabel}
          selection={isLoading ? SELECTION_TYPE.LOADING : SELECTION_TYPE.MULTIPLE}
          maxSelections={5}
        />
        {!isExclude && (
          <Toggle
            isDark
            updateValue={value => {
              setCombination(value)
            }}
            value={combination}
            uiSchema={{size: 'small', label: 'Combination of Products'}}
          />
        )}
        <div className="my-4 h-[1px] bg-[#4E4E4E]" />
      </div>
    </>
  )
}

export default ProductAndBrandContent
